import { FC, useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { httpServices } from '@/api/client';
import CenteredSpin from '@/components/CenteredSpin';
import { AppConstants, COOKIE_MAX_AGE } from '@/utils/constants';

const AuthCallbackPage: FC = () => {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const extractTokenFromUrl = () => {
      let token: string | null = null;

      const hash = location.hash;
      const search = location.search;

      if (hash) {
        const hashParams = new URLSearchParams(hash.substring(1));
        token = hashParams.get('access_token') || hashParams.get('token');
      }

      if (!token && search) {
        token = searchParams.get('access_token') || searchParams.get('token');
      }

      if (token) {
        httpServices.llmService.updateToken(token);
        httpServices.saasService.updateToken(token);
        document.cookie = `access_token=${token}; path=/; max-age=${COOKIE_MAX_AGE}; secure; samesite=strict; domain=${AppConstants.DOMAIN}`;

        const cleanUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }

      return token;
    };

    const token = extractTokenFromUrl();

    if (!isLoading) {
      if (isAuthenticated || token) {
        navigate('/', { replace: true });
      } else if (error) {
        navigate('/signin', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, error, navigate, location, searchParams]);

  return <CenteredSpin />;
};

export default AuthCallbackPage;
